import { render } from "./PublicShow.vue?vue&type=template&id=f27a3f2a&scoped=true"
import script from "./PublicShow.vue?vue&type=script&lang=js"
export * from "./PublicShow.vue?vue&type=script&lang=js"

import "./PublicShow.vue?vue&type=style&index=0&id=f27a3f2a&scoped=true&lang=css"

import exportComponent from "/Users/david/Desktop/projects/Realgestion/rg-massive-camoruco/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27a3f2a"]])

export default __exports__